export const INSTALL_EXTENSION_URL =
  "https://chromewebstore.google.com/detail/yolk-sales-call-assistant/mlleoaegihnmejbeamoapbgpelchaegd";

export const BOOK_DEMO_URL = "https://form.typeform.com/to/PyPqtNed";
